import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiUrl } from "../../constants";
import styles from "./PublisherIcon2.module.css";

const PublisherIcon = ({ publisher }) => {
  const [icon, setIcon] = useState(null);

  useEffect(() => {
    async function getPublishers() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(
          `${apiUrl}/api/formsettings/publishers2`,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );

        data.forEach((currentPublisher) => {
          if (currentPublisher.publisher.indexOf(publisher) !== -1
            && currentPublisher.filename !== ""
            && currentPublisher.path !== ""
          ) {
            getPublisherLogo(currentPublisher._id);
          }
        });
      } catch (e) {
        console.error(e);
      }
    }
    getPublishers();
  }, [publisher]);

  async function getPublisherLogo(publisherId) {
    const jwtToken = localStorage.getItem("token");
    try {
      const { data } = await axios.get(
        `${apiUrl}/api/formsettings/publishersicon2/${publisherId}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      let fileType = "";
      if (data.charAt(0) === "/") {
        fileType = "jpeg";
      }
      if (data.charAt(0) === "i") {
        fileType = "png";
      }

      const image = `data:image/${fileType};base64,${data}`;

      setIcon(image);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <>
      {icon && (
        <img
          className={`${styles.publisherIcon}`}
          src={icon}
          alt={publisher}
        />
      )}
      {!icon && (publisher)}
    </>
  );
};

export default PublisherIcon;
